import { Color, Icon } from '@billy/design-system'
import { ReactNode } from 'react'

import { Gmail, Microsoft } from '../../../../../assets/images'
import { ScoutProvider } from '../../../enums/scoutProvider'

export const providersImage: Record<ScoutProvider, ReactNode> = {
  [ScoutProvider.Google]: <Gmail />,
  [ScoutProvider.Microsoft]: <Microsoft />,
  [ScoutProvider.Imap]: <Icon icon="mail" size="lg" color={Color.Grey500} />,
}
